export default function importExportFilter() {
    return value => {
        const allowable = {
            true: 'Import',
            false: 'Export'
        };

        return allowable[value] || 'Unknown';
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/filters/importExport.js